import computed from './computed'
import data from './data'
import components from './components'

export default {
  computed,
  data,
  components,
  resourcePath: '/v1/dweller/rent/unit'
}



// WEBPACK FOOTER //
// ./src/app/tenant/rental/resources/index.js